/** Réglages du fond Nyan Cat (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    vitesse: {
        type: "nombre", libelle: "Vitesse de l'animation", min: 0.5, max: 2, pas: 0.1, defaut: 1, unite: "×",
        aide: "Rythme du chat, de l'arc-en-ciel et des étoiles. ×1 est la vitesse d'origine.",
    },
    etoiles: {
        type: "interrupteur", libelle: "Étoiles qui scintillent", defaut: true,
        aide: "Décocher pour un fond plus calme : seuls le chat et l'arc-en-ciel restent.",
    },
};
